import _ from 'underscore';

export const flexibleGrid = () => ({
  display: 'grid',
  fallbacks: [
    {
      display: '-ms-grid',
    },
  ],
});

const flexibleGridItem = () => ({
  justifySelf: 'stretch',
  '-ms-grid-column-align': 'stretch',
});

export const flexibleGridRow = number => ({
  extend: flexibleGridItem(),
  '-ms-grid-row': `${number}`,
  gridRowStart: `${number}`,
});

export const flexibleGridRowSpan = number => ({
  '-ms-grid-row-span': `${number}`,
  gridRowEnd: `span ${number}`,
});

export const flexibleGridRows = (isGlobal, containerName, number) =>
  _.chain(_.range(1, number + 1))
    .map(index => ({
      [isGlobal ?
        `.${containerName}__flexible-grid-row-${index}` :
        `${containerName}FlexibleGridRow${index}`]: flexibleGridRow(index),
      [isGlobal ?
        `.${containerName}__flexible-grid-row-span-${index}` :
        `${containerName}FlexibleGridRowSpan${index}`]: flexibleGridRowSpan(index),
    }))
    .reduce((m, o) => ({ ...m, ...o }))
    .value();

export const flexibleGridColumn = number => ({
  extend: flexibleGridItem(),
  '-ms-grid-column': `${number}`,
  gridColumnStart: `${number}`,
});

export const flexibleGridColumnSpan = number => ({
  '-ms-grid-column-span': `${number}`,
  gridColumnEnd: `span ${number}`,
});
